import React, { useCallback } from "react";
import { Box, Button, Dialog, DialogContent, MenuItem, Paper, TextField, Typography } from '@mui/material'
import { DialogFooter, DialogHeader } from 'components/dialog/DialogHeader';
import PaperComponent from "components/PaperComponent";
import { BoxFC, BoxFR } from "components/BoxCustom";
import { billingNoteColNm } from "constants/billingNoteConstant";
import { invColumns, searchInvColumns } from "./columns";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import useBillingNoteDialog from "./useBillingNoteDialog";
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import DateTimeSelect from "components/DateTimeSelect";
import ComboBox from "components/ComboBox";
import { initSearchInv } from "./initData";
import SearchButton from "components/buttons/SearchButton";
import { useMemo } from "react";
import { DesktopDatePicker } from '@mui/x-date-pickers';
import '@mui/lab';



const BillingNoteDialog = ({ selectedId, dialogOpen, setDialogOpen, onFinish }) => {
  const { state, fn } = useBillingNoteDialog({ selectedId, dialogOpen, onFinish })
  const { dialogData, dataRows, msData, searchInvFilterData, searchInvData, validation } = state


  const dialogDataProp = useCallback((name, disabled) => ({
    variant: 'outlined',
    size: 'small',
    name: name,
    fullWidth: true,
    disabled: disabled,
    label: billingNoteColNm[name],
    value: dialogData[name],
    error: validation[name],
    onChange: (e) => { fn.setDialogData((oldState) => ({ ...oldState, [name]: e.target.value })) }
  }), [dialogData, fn, validation])

  const datePickerProp = useCallback((name, required) => ({
    label: billingNoteColNm[name],
    inputFormat: "DD/MM/YYYY",
    mask: "__/__/____",
    value: dialogData[name],
    onChange: (newValue) => { fn.setDialogData(oldState => ({ ...oldState, [name]: newValue && newValue.format("YYYY-MM-DD") })) },
    renderInput: (params) => <TextField size="small"  {...params} fullWidth error={validation[name]} required={required} />,
  }), [dialogData, fn, validation])

  const isDisableSelectedAll = useMemo(() => {
    if (searchInvData.length === 0) return true
    const firstCusId = searchInvData[0].CusId
    for (let i = 1; i < searchInvData.length; i++) {
      if (searchInvData[i].CusId !== firstCusId) return true
    }
    return false
  }, [searchInvData])
  console.log("BillingNoteDialog state::", state)
  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth 
      // maxWidth={selectedId === 0 ? 'xl' : 'lg'} 
      PaperProps={{
        style: {
          minWidth: selectedId === 0? 1800: 1500,
          maxWidth: selectedId === 0? 1800: 1500,
        }
      }}>
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title={selectedId > 0 ? "ข้อมูลใบวางบิล" : "เพิ่มใบวางบิล"}
        onDeleteClick={selectedId > 0 ? () => fn.deleteBillingNote(selectedId) : null}
      />
      <DialogContent sx={{ bgcolor: "#f9f9f9" }}>
        <BoxFR sx={{ flexGrow: 1, mt: 2 }}>
          {selectedId === 0 &&
            <BoxFC alignSelf="stretch">
              <Paper sx={{ px: 2, py: 1, width: 580, height: "100%", display: "flex", flexDirection: "column" }}>
                <Typography variant="h6">เลือกใบแจ้งหนี้</Typography>
                <BoxFC pt={1} flexGrow={1}>
                  <BoxFR>
                    <DateTimeSelect
                      sx={{ width: 180 }}
                      label="วันที่ใบแจ้งหนี้"
                      start={initSearchInv.InvDteSt}
                      end={initSearchInv.InvDteEn}
                      setSelectDate={(start, end) => { fn.setSearchInvFilterData(o => ({ ...o, InvDteSt: start, InvDteEn: end })) }}
                    />
                    <ComboBox sx={{ width: 200, flexGrow: 1 }} options={msData.cusCombo} label="ลูกค้า"
                      selectedId={searchInvFilterData.CusId}
                      setSelectedId={(id) => fn.setSearchInvFilterData(o => ({ ...o, CusId: id }))}
                    />
                  </BoxFR>
                  <BoxFR>
                    <Button variant="contained" onClick={fn.selectInvoiceAll} disabled={isDisableSelectedAll}>เลือกทั้งหมด</Button>
                    <Box flexGrow={1} />
                    <SearchButton onClick={fn.handleSearchClick} />
                  </BoxFR>

                  <Box width='100%' flexGrow={1}>
                    <DataGridCellExpand
                      hideToolbar
                      hideFooter
                      rows={searchInvData}
                      columns={searchInvColumns(fn.selectInvoice)} />

                  </Box>

                </BoxFC>
              </Paper>
            </BoxFC>
          }
          <BoxFC sx={{ flexGrow: 1 }}>
            <Paper sx={{ px: 2, py: 1 }}>
              <Typography variant="h6">รายละเอียดใบวางบิล</Typography>
              <BoxFC pt={1}>
                <BoxFR>
                  <BoxFR flexGrow={1}>
                    <TextField {...dialogDataProp("BNNo", selectedId > 0)} required />
                    {selectedId === 0 && <Button variant="contained" onClick={fn.generateBNNo}>GEN</Button>}
                  </BoxFR>
                  <BoxFR flexGrow={1}>
                    <DesktopDatePicker {...datePickerProp("BNDte", true)} disabled={selectedId > 0} />
                  </BoxFR>
                  <BoxFR flexGrow={1}>
                    <DesktopDatePicker {...datePickerProp("RecvPayDte", true)} />
                  </BoxFR>
                </BoxFR>
                <BoxFR>
                  <TextField {...dialogDataProp("Rmk", false)} multiline rows={2} />
                  {selectedId > 0 &&
                    <Button sx={{ width: 150 }} variant="contained" onClick={fn.handleEditRmk}>บันทึกหมายเหตุและวันที่รับเงิน</Button>}
                </BoxFR>
              </BoxFC>
              {/* <BoxFR mt={2}>
                <CheckboxFormControl label="พิมพ์หัก ณ ที่จ่าย" checked={isPrintWht}
                  onChange={(e) => fn.setIsPrintWht(e.target.checked)} />
              </BoxFR> */}
              <Box width='100%' mt={1} height={250}>
                <DataGridCellExpand
                  hideFooter
                  rowReordering
                  onRowOrderChange={fn.handleRowOrderChange}
                  rows={dataRows}
                  onSortModelChange={(newSortModel) => fn.handleSortModelChange(newSortModel)}
                  columns={invColumns(selectedId === 0 && fn.handleDeleteRow)} />
              </Box>
            </Paper>

            <Paper sx={{ px: 2, py: 1, mt: 1 }}>
              <Typography variant="h6">พิมพ์ใบวางบิล</Typography>
              <BoxFC mt={1}>
                <BoxFR>
                  <TextField {...dialogDataProp("BillNm", false)} />
                  <TextField {...dialogDataProp("BillTaxId", false)} sx={{ width: 250 }} />
                  <TextField {...dialogDataProp("Lang", false)} sx={{ width: 200 }} select label="ภาษา">
                    <MenuItem value="TH">ไทย</MenuItem>
                    <MenuItem value="CN">จีน</MenuItem>
                  </TextField>
                  <Button variant="contained" sx={{ width: 350 }} onClick={fn.handlePrintBillingNote}>
                    <PrintRoundedIcon sx={{ mr: 1 }} />
                    {selectedId === 0 && `เพิ่มและ`}พิมพ์ใบวางบิล
                  </Button>
                </BoxFR>
                <BoxFR>
                  <TextField {...dialogDataProp("BillAddr", false)} multiline rows={2} />
                </BoxFR>
              </BoxFC>
            </Paper>
          </BoxFC>
        </BoxFR>

      </DialogContent>
      <DialogFooter okText={selectedId > 0 ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={selectedId === 0 && fn.insertBillingNote} />
    </Dialog>
  )
}

export default React.memo(BillingNoteDialog)